<template>
  <v-container>
    <v-card flat style="position: relative">
      <v-card-title>
        <h4>Detalle</h4>
        <v-spacer></v-spacer>
        <v-progress-circular v-if="loader" :size="25" color="primary" indeterminate></v-progress-circular>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md class="pl-0 pr-0">
          <v-layout row wrap v-if="data != null">
            <v-flex md12 sm6 style="text-align: center">
              <strong>ATM N°:</strong>
              <br />
              {{ data.agent_id }}
            </v-flex>
            <v-flex md6 sm6 class="mb-3" style="text-align: center">
              <strong>Tipo:</strong>
              <br />
              {{ data.type }}
            </v-flex>
            <v-flex md6 sm6 class="mb-3" style="text-align: center">
              <strong>Número de expediente:</strong>
              <br />
              NO POSEE
            </v-flex>
            <v-flex md6 sm6 class="mb-3" style="text-align: center">
              <strong>Estado actual:</strong>
              <br />
              {{ data.status }}
            </v-flex>
            <v-flex md6 sm6 class="mb-3" style="text-align: center">
              <strong>Fecha de ingreso:</strong>
              <br />
              {{ data.created }}
            </v-flex>
            <v-flex md12 sm6 class="mb-3" style="text-align: center">
              <strong>Fecha vencimiento:</strong>
              <br />
              NO POSEE
            </v-flex>
             <v-flex md12 sm6 class="mb-3" style="text-align: center">
              <strong>Observaciones:</strong>
              <span >{{ data.observations }}</span>
            </v-flex>
            <v-flex md12 sm6 style="text-align: center" v-if="data.attachment != null">
              <v-btn color="info" @click="getAttachament(data.attachment)">Ver documento adjunto</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="error">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
      fullscreen
      v-model="dialog.attachment"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-toolbar dark color="primary">
        <h4>Documento probatorio adjunto</h4>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="dialog.attachment = false">Cerrar</v-btn>
      </v-toolbar>
      <v-card>
        <v-card-text v-if="data != null">
          <img :src="data.attachment" width="100%" style="border-radius: 5px;" alt />
        </v-card-text>
      </v-card>
      <v-toolbar dar color="primary">
        <v-spacer></v-spacer>
        <v-btn color="error" @click="dialog.attachment = false">Cerrar</v-btn>
      </v-toolbar>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "@/api/axios/config";

export default {
  data() {
    return {
      loader: true,
      data: null,
      dialog: {
        attachment: false
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      axios
        .get("gn/nueva-data-2/" + this.$route.params.id)
        .then(response => {
          if (response.data.status) {
            this.data = response.data.items;
          } else {
            this.snackbar = {
              icon: "error",
              text: "Ocurrió un error en el servidor...",
              color: "error",
              show: true
            };
          }
        })
        .catch(error => {
          this.snackbar = {
            icon: "error",
            text: error,
            color: "error",
            show: true
          };
        })
        .finally(() => {
          this.loader = false;
        });
    },
    close() {
      this.$router.push("/GN/agente-archivo-gn/historial-gn");
    },
    getAttachament(url) {
      window.open(url, "_blank");
    }
  }
};
</script>